import React from 'react';
import { FileTextIcon, ZapIcon, LockIcon } from 'lucide-react';
import { PriceBlock } from './PriceBlock';
import { HERO_IMAGE_URL } from '../utils/headMeta';
const HERO_IMG = HERO_IMAGE_URL;
/** Intrinsic size of the mockup — used to reserve layout space (avoids CLS). */
const HERO_IMG_WIDTH = 1400;
const HERO_IMG_HEIGHT = 1120;
const badges = [{
  icon: FileTextIcon,
  label: '100% PDF'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}];
const trust = [{
  icon: LockIcon,
  label: 'Pago seguro'
}];
export function Hero() {
  return <section id="hero" className="relative overflow-hidden bg-blush" data-id="element-126" data-mp="xaxj7zl80aqv">
      <div className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-rose/10 blur-3xl" aria-hidden data-id="element-127" data-mp="sa9q98dflju0" />
      <div className="absolute -bottom-32 -left-24 h-80 w-80 rounded-full bg-rose-soft/20 blur-3xl" aria-hidden data-id="element-128" data-mp="nb6njukxbpp7" />

      <div className="relative mx-auto max-w-3xl px-5 py-8 sm:py-12" data-id="element-129" data-mp="3d33ecx6girk8">
        <div className="animate-hero-copy" data-id="element-130" data-mp="3825wymt9u1js">
          <p className="text-center font-display text-base font-semibold text-rose-deep sm:text-lg" data-id="element-131" data-mp="384jsewrv5frv">
            ESTÉTICA DIGITAL PRO™ · Mega Pack 6 en 1
          </p>
          <h1 className="mt-2.5 text-center font-display text-[1.75rem] font-black leading-[1.12] text-ink sm:text-4xl lg:text-5xl" data-id="element-132" data-mp="3o6apvvoqw6zy">
            Dejá de improvisar el Instagram de tu estética y empezá a usarlo para{' '}
            <span className="bg-gradient-to-r from-[#3e4ee9] via-[#9750d8] to-[#ff7396] bg-clip-text text-transparent" data-id="element-133" data-mp="3e7l6tzl44gi4">
              generar consultas y turnos.
            </span>
            <img src={HERO_IMG} alt="Mega Pack Estética Digital Pro con seis tomos, plantillas y recursos para marketing de estéticas" width={HERO_IMG_WIDTH} height={HERO_IMG_HEIGHT} fetchPriority="high" decoding="async" sizes="(max-width: 640px) 58vw, (max-width: 1024px) 66vw, 600px" style={{
            aspectRatio: `${HERO_IMG_WIDTH} / ${HERO_IMG_HEIGHT}`
          }} className="mx-auto mt-5 block h-auto w-[58%] max-w-full object-contain sm:w-[70%]" data-id="element-134" data-mp="359j8xswoe3z2" />
          </h1>

          <p className="mt-3 text-center text-[14px] leading-relaxed text-ink/75 sm:text-base" data-id="element-135" data-mp="s2b9g2qj4r79">
            Estética Digital PRO es un sistema práctico 6 en 1 para organizar tu contenido, mejorar
            tu imagen, crear Stories y Reels con intención y convertir consultas en pacientes, sin
            ser experta en marketing.
          </p>

          <p className="mt-3 text-center text-[13px] font-semibold text-rose-deep" data-id="element-136" data-mp="db2c17gdy1jk">
            No necesitás convertirte en community manager para tener un Instagram que trabaje a
            favor de tu estética.
          </p>

          <PriceBlock className="mt-5" data-id="element-137" data-mp="112g4reig7z52" />

          <p className="mt-3 text-center text-[12px] leading-relaxed text-ink/60" data-id="element-138" data-mp="111esj6pp56lr">
            Todo organizado paso a paso. Para que puedas aplicarlo aunque hoy no sepas qué publicar.
          </p>

          <div className="mt-4 flex flex-wrap items-start justify-center gap-2" data-id="element-139" data-mp="3ltqeji9dp5w5">
            {badges.map(b => <span key={b.label} className="inline-flex items-center gap-1.5 rounded-full bg-white px-3 py-1.5 text-xs font-semibold text-ink/80 shadow-sm" data-id="element-140" data-mp="3hqkamh9qnqsu">
                <b.icon className="h-3.5 w-3.5 text-rose" data-id="element-141" data-mp="21amwfav61umv" />
                {b.label}
              </span>)}
            {trust.map(t => <span key={t.label} className="inline-flex items-center gap-1.5 rounded-full bg-white px-3 py-1.5 text-xs font-semibold text-ink/80 shadow-sm" data-id="element-142" data-mp="269r2hsmsnc8z">
                <t.icon className="h-3.5 w-3.5 text-rose" data-id="element-143" data-mp="2b2kbwtt7j8re" />
                {t.label}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}